import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /**
   * MYFASHION: su desktop si usa la pagina carrello (più leggibile, anche su schermi bassi come il PC cassa);
   * il cassetto resta solo su mobile.
   */
  get #useCartPage() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  get #cartUrl() {
    return `${window.Shopify?.routes?.root ?? '/'}cart`;
  }

  get #onCartPage() {
    return window.location.pathname.replace(/\/$/, '').endsWith('/cart');
  }

  #handleCartAdd = (/** @type {CartAddEvent} */ event) => {
    if (event.detail?.data?.didError) return;

    if (this.#useCartPage) {
      // Sulla pagina carrello (es. confezione regalo) il contenuto si aggiorna da solo
      if (!this.#onCartPage) window.location.assign(this.#cartUrl);
      return;
    }

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    if (this.#useCartPage) {
      if (!this.#onCartPage) window.location.assign(this.#cartUrl);
      return;
    }

    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
